import { gql } from '@apollo/client';

export const FETCH_FUNNEL_CONFIGURATION = gql`
  query Flex_FetchFunnelConfiguration(
    $zipCode: Int!
    $utilityId: Int!
    $partnerId: String
    $customerType: String
    $requireFico: Boolean
    $perchSfProductId: String
    $stateId: Int
    $programId: String
    $countyId: Int
  ) {
    resolveFunnelConfig(
      zipCode: $zipCode
      utilityId: $utilityId
      partnerId: $partnerId
      customerType: $customerType
      requireFico: $requireFico
      perchSfProductId: $perchSfProductId
      stateId: $stateId
      programId: $programId
      countyId: $countyId
    ) {
      paymentProvider
      perchSfProductId
      isCapacityAvailable
      productSignupContractTemplateIds
      proofDocRequirement
      projectDetails
      savingsPercentage
      signUpContractTemplateId
      supportedCustomerTypes
      requireFicoCheck
      requireFicoCheckForLmiProduct
      requireFicoCheckForDefaultProduct
      countyProjectMatch
    }
  }
`;
